import { Button, ButtonProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Comment } from '@/resources/Comment';

export interface ICommentCountButtonProps extends ButtonProps {
  comment?: Comment;
}

export const CommentReplyButton: FC<ICommentCountButtonProps> = ({ comment, onClick }) => {
  const { t } = useTranslation();

  return (
    <Button variant="link" ml={4} size="sm" onClick={onClick}>
      {t('comments.replies.button.label', {
        count: comment.metadata.repliesCount,
        context: `${comment.metadata.repliesCount}`,
      })}
    </Button>
  );
};
